$(document).ready(function(){
      



  // ========================================================================================

  
  // $('.packet_options').change(function(){

  //     var pack_value = $(this).val();
  //     var pack_number = $(this).find('option:selected').attr('pack-quantities');
  //    var pack_product_variant_id = $(this).find('option:selected').attr('prd-variant');
  //   console.log("pack_product_variant_id", pack_product_variant_id);
  //     if(pack_product_variant_id != undefined)
  //     {
  //         $('.product_buy_item').val(pack_product_variant_id);  
  //     }
  //     else
  //     {
          
  //     }
  //     $('#product-packs').val(pack_value);
  //     // $('.product-form__input .quantity__input').val(pack_number);
  // })

  $('.app_block').addClass('hidden');

  $(document).on('click', '.product_packs', function() {
        $('.product-form__submit').removeClass('product_desabled');
        $('.product_quantity_box').removeClass('hidden');
        $('.product_packs').removeClass('active_pack');
        var pack_value = $(this).val();
        var pack_product_variant_id = $(this).attr('prd-variant');
        $(this).addClass('active_pack');
        if(pack_product_variant_id != undefined)
        {
            $('.product_buy_item').val(pack_product_variant_id);  
        }
    
        $('#product-packs').val(pack_value);
    
  });
  $(document).on('click','.product_variant_picker', function(){
         $('.product-form__submit').removeClass('product_desabled');
        $('.product_quantity_box').removeClass('hidden');
      $(this).closest('.product_information_layout').find('.app_block').removeClass('hidden');
      $('.product-form__submit').removeClass('hidden');
      var pack_values= $(this).attr('pack-vlaue');
       updatetigger();
  })

function updatetigger(){
  setTimeout(function(){

    $('.product_add_button').prop('disabled', false);
    	
    var $originalButton = $('#ProductSubmitButton-template--19395503849696__main');
    var $clonedButton = $originalButton.clone(true).off(); // remove all handlers
    $originalButton.replaceWith($clonedButton);
  
    var $container = $('.loop-widget-purchase-options-container');
    
    //if ($container.length) {
      //$container.on('click', '.loop-widget-purchase-option', function (e) {
         $('body').on('click', '.loop-widget-purchase-option', function (e) {
        var $clickedOption = $(this);
        var isOneTime = $clickedOption.is('[data-loop-widget-onetime-purchase-option]');
        var isSubscription = $clickedOption.is('[data-loop-widget-selling-plan-group]');
    
        if (isOneTime) {
          $('#ProductSubmitButton-template--19395503849696__main').text('Add to cart');
          // Add logic for one-time purchase here
        } else if (isSubscription) {
          $('#ProductSubmitButton-template--19395503849696__main').text('Add subscription to cart');
          // Add logic for subscription here
        }
      });
    //}
    
    // Handle Add to Cart button click
    $clonedButton.on('click', function (e) {
    
      e.preventDefault();
    
      var pack_data = $('.product_option_button input:checked').attr('pack-number');
      var $form = $clonedButton.closest('form');
      var formDataArray = $form.serializeArray();
      var formData = {};
    
      $.each(formDataArray, function (_, field) {
        formData[field.name] = field.value;
      });
      
      var current_quantity = Number(formData['quantity'] || 1);
      // var updated_quantity = parseInt(current_quantity) * parseInt(pack_data);
      
      var cartItem = {
        id: formData['id'],
            quantity: current_quantity
      };
    
      if (formData['selling_plan']) {
        cartItem.selling_plan = formData['selling_plan'];
      }  
    
      $.ajax({
        url: '/cart/add.js',
        method: 'POST',
        contentType: 'application/json',
        dataType: 'json',
        data: JSON.stringify(cartItem),
        success: function (data) {
          if (window.Rebuy?.SmartCart?.show) {
            Rebuy.SmartCart.show();
          }
        },
        error: function (xhr, status, error) {
          console.error('❌ Error adding product:', error);
        }
      });
    });
  },200);
}



  var pathname = window.location.pathname;
  var page_template = pathname.split('/')[1];
  if(page_template == "products")
  {
    const currentProductURL = new URL(window.location.href);
    currentProductURL.searchParams.delete('variant');
    history.replaceState(history.state, '', currentProductURL.toString());

     $('.product_option_button input[type="radio"]').each(function() {
        // Remove the checked property (actual selection)
        $(this).prop('checked', false);
    
        // Optionally also remove the HTML attribute if you care
        $(this).removeAttr('checked');
      });
  }
  
  
});